import { Helmet } from "react-helmet-async";
import { Outlet } from "react-router";

import HeaderLayout from "@/common/components/HeaderLayout";
import { spanToScore } from "@/common/components/SatisfactionFilter";
import { FeedbackTable } from "@/feedback/components/FeedbackTable";
import { useFeedbackData } from "@/feedback/data/useFeedbackData";
import { useFeedbackTableState } from "@/feedback/hooks/useFeedbackTableState";

export default function Feedback() {
  const {
    sorting,
    pageIndex,
    satisfactionFilter,
    featureFilter,
    companyFilter,
    funnelStepsFilter,
    segmentFilter,
  } = useFeedbackTableState();

  // We only handle sorting one column for now
  const { id: sortBy, desc: sortDesc } = sorting[0] ?? {};
  const { data, isLoading, isFetching, isError, refetch } = useFeedbackData({
    sortBy,
    sortOrder:
      sortDesc === true ? "desc" : sortDesc === false ? "asc" : undefined,
    pageIndex,
    // Filters
    satisfaction: spanToScore(satisfactionFilter),
    featureId: featureFilter,
    companyId: companyFilter,
    funnelSteps: funnelStepsFilter,
    segmentId: segmentFilter,
  });

  return (
    <>
      <HeaderLayout title="Feedback" borderless>
        <>
          <Helmet>
            <title>Feedback</title>
          </Helmet>
          <FeedbackTable
            data={data}
            isError={isError}
            isFetching={isFetching}
            isLoading={isLoading}
            onRetry={refetch}
          />
        </>
      </HeaderLayout>
      <Outlet />
    </>
  );
}
